export default __webpack_public_path__ + "img/9c02e346c2bd6656baafa6a3aab5019c.png";